import { render, staticRenderFns } from "./userCard.vue?vue&type=template&id=b6b6626e&scoped=true&"
import script from "./userCard.vue?vue&type=script&lang=ts&"
export * from "./userCard.vue?vue&type=script&lang=ts&"
import style0 from "./userCard.vue?vue&type=style&index=0&id=b6b6626e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b6626e",
  null
  
)

export default component.exports